<template>
    
    <v-container v-if="superUser || permission " fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
                show-arrows
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize text-left text-md-center
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
 
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/general/settings/billingDashboard";

export default {
    name: "Developers",

    mixins: [translations],

    data() {
        return {
            tab: this.$route.path,
     
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "panelType",
            "permissions",
            "storePermissions"
        ]),
        

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return this.superUser || (this.$store.state.permissions
                ? this.$store.state.permissions.developers?.read
                : null);
        },


        tabs() {
            let arr = [];
            if (this.getPermission('api_keys.read')) {
                arr.push({
                    name: { el: "Κλειδιά Api", en: "Api Keys", it: "Chiavi Api" },
                    to: `/${this.lang}/${this.panelType}/general-settings/developers/api-keys`,
                });
            }
           
            if (this.getPermission('webhooks.read')) {
                arr.push({
                    name: { el: "Webhooks", en: "Webhooks", it: "Webhooks" },
                    to: `/${this.lang}/${this.panelType}/general-settings/developers/webhooks`,
                });
            }

            if (this.getPermission('webhooks_responses.read')) {
                arr.push({
                    name: { el: "Webhook Responses", en: "Webhook Responses", it: "Webhook Responses" },
                    to: `/${this.lang}/${this.panelType}/general-settings/developers/webhook-responses`,
                });
            }

            if (this.getPermission('webhooks_logs.read')) {
                arr.push({
                    name: { el: "Webhook Logs", en: "Webhook Logs", it: "Webhook Logs" },
                    to: `/${this.lang}/${this.panelType}/general-settings/developers/webhook-logs`,
                });
            }

            return arr;
        },

    },

    methods: {
      
        ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),


        getPermission(path) {
            return  this.superUser || (
                eval("this.permissions.developers." + path) &&
                eval("this.storePermissions.developers." + path)
            );
        },

    },

    watch: {
        permission: {
            // immediate: true,
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/${this.panelType}/forbidden-gateway`
                    );
                }
            },
        },
     
    },

    mounted() {
        if (this.$route.name == 'Developers') {
            this.$router.replace({ path: `/${this.lang}/${this.panelType}/general-settings/developers/api-keys`})
        }
    },
    

};
</script>
<style>


.relative {
    position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}

</style>
